"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getFlexMenuData = exports.updateDesign = exports.getPrimaryLangugage = exports.getAvailableLanguages = exports.getLanguageCodeForRegion = exports.getAvailableCountries = exports.getFlexUrls = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _CordovaFileHelper = _interopRequireWildcard(require("./CordovaFileHelper"));

// import StringHelper from './StringHelper'
// let FLEX_MENU_URL = 'https://ecloud-dev.equeo.de/flexmenu'
// const getFlexMenu = async () => {
//   const flexMenu = await DataStore.getElementByPath(DATA_STORE_PATHS.TC_FLEXMENU)
//   FLEX_MENU = flexMenu
// }
// export const reloadFlexMenu = async () => {
//   const downloadFolder = await CordovaFileHelper.getDownloadFolder()
//
//   await CordovaFileHelper.downloadFile(FLEX_MENU_URL, downloadFolder, LOCAL_FILENAMES.FLEXMENU)
//   console.log('downloaded flex menu')
//
//   const dataFolder = await CordovaFileHelper.getFolderEntry(LOCAL_FILENAMES.DATA_FOLDER)
//
//   console.log(downloadFolder, dataFolder)
//
//   await CordovaFileHelper.copyFile(downloadFolder, LOCAL_FILENAMES.FLEXMENU, dataFolder, LOCAL_FILENAMES.FLEXMENU, true)
//
//   const newFlexText = await CordovaFileHelper.readTextFile(LOCAL_FILENAMES.FLEXMENU, LOCAL_FILENAMES.DOWNLOAD_FOLDER)
//   const newFlexJson = JSON.parse(newFlexText)
//   console.log(newFlexJson)
//   await DataStore.setSingleData(DATA_STORE_PATHS.TC_FLEXMENU, newFlexJson)
// }
var getFlexUrls = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(regionCode) {
    var flexMenu, flexCountry, language, langCode, privacyUrlToUse;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log('getUrls', regionCode);
            _context.next = 3;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU);

          case 3:
            flexMenu = _context.sent;
            flexCountry = flexMenu.countries.find(function (country) {
              return country.countryCode === regionCode;
            });
            console.log('getUrls', flexCountry);

            if (!flexCountry) {
              _context.next = 15;
              break;
            }

            console.log('getUrls return url', flexCountry.privacyURL, flexCountry.feedbackUrl);
            language = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE);
            langCode = language.languageCode;
            privacyUrlToUse = flexCountry["privacyURL_".concat(langCode)] ? flexCountry["privacyURL_".concat(langCode)] : flexCountry.privacyURL;
            console.log('privacyURL to return', privacyUrlToUse, flexCountry, language, "privacyURL_".concat(langCode));
            return _context.abrupt("return", {
              privacy: privacyUrlToUse,
              feedback: flexCountry.feedbackUrl
            });

          case 15:
            return _context.abrupt("return", {
              privacy: null,
              feedback: null
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getFlexUrls(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getFlexUrls = getFlexUrls;

var getAvailableCountries = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(langCode) {
    var flexMenu, countries;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU);

          case 2:
            flexMenu = _context2.sent;
            countries = [];

            if (flexMenu) {
              flexMenu.countries.forEach(function (country) {
                countries.push({
                  name: country.country,
                  translation: _config["default"].tcCountryHelper.getTranslatedCountryNameByName(country.country, langCode),
                  countryCode: country.countryCode
                });
              });
            }

            return _context2.abrupt("return", countries);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAvailableCountries(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getAvailableCountries = getAvailableCountries;

var getLanguageCodeForRegion = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(region) {
    var flexMenu, flexCountry;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU);

          case 2:
            flexMenu = _context3.sent;
            flexCountry = flexMenu.countries.find(function (country) {
              return country.country === region;
            });

            if (!flexCountry) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", flexCountry.languageCode);

          case 8:
            return _context3.abrupt("return", null);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getLanguageCodeForRegion(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.getLanguageCodeForRegion = getLanguageCodeForRegion;

var getAvailableLanguages = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var regionCode,
        flexMenu,
        homeRegionCode,
        languages,
        flexCountry,
        primaryLang,
        _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            regionCode = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
            console.log('getAvailableLanguages', regionCode);
            _context4.next = 4;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU);

          case 4:
            flexMenu = _context4.sent;
            _context4.next = 7;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE);

          case 7:
            _context4.t0 = _context4.sent;

            if (_context4.t0) {
              _context4.next = 10;
              break;
            }

            _context4.t0 = regionCode;

          case 10:
            homeRegionCode = _context4.t0;
            languages = [];

            if (homeRegionCode) {
              _context4.next = 14;
              break;
            }

            return _context4.abrupt("return");

          case 14:
            if (flexMenu) {
              flexCountry = flexMenu.countries.find(function (country) {
                return country.countryCode === homeRegionCode;
              });
              primaryLang = flexCountry.availableLanguages[flexCountry.languageCode]; // pushing primary language first to make sure it is the first shown

              languages.push({
                language: primaryLang,
                languageCode: flexCountry.languageCode
              });

              if (flexCountry) {
                (0, _keys["default"])(flexCountry.availableLanguages).forEach(function (languageCode) {
                  if (languageCode !== flexCountry.languageCode) {
                    languages.push({
                      language: flexCountry.availableLanguages[languageCode],
                      languageCode: languageCode
                    });
                  }
                });
              }
            }

            return _context4.abrupt("return", languages);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getAvailableLanguages() {
    return _ref4.apply(this, arguments);
  };
}();

exports.getAvailableLanguages = getAvailableLanguages;

var getPrimaryLangugage = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(regionCode) {
    var flexMenu, homeRegionCode, flexCountry;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU);

          case 2:
            flexMenu = _context5.sent;
            _context5.next = 5;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE);

          case 5:
            _context5.t0 = _context5.sent;

            if (_context5.t0) {
              _context5.next = 8;
              break;
            }

            _context5.t0 = regionCode;

          case 8:
            homeRegionCode = _context5.t0;

            if (homeRegionCode) {
              _context5.next = 11;
              break;
            }

            return _context5.abrupt("return");

          case 11:
            if (!flexMenu) {
              _context5.next = 14;
              break;
            }

            flexCountry = flexMenu.countries.find(function (country) {
              return country.countryCode === homeRegionCode;
            });
            return _context5.abrupt("return", flexCountry.languageCode);

          case 14:
            return _context5.abrupt("return", null);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getPrimaryLangugage(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

exports.getPrimaryLangugage = getPrimaryLangugage;

var updateDesign = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(homeRegionCode) {
    var flexMenu, homeCountryCode, flexHome, usesNewDesign, usesNewDesignToSet;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU);

          case 2:
            flexMenu = _context6.sent;
            homeCountryCode = homeRegionCode || 'DE';

            if (!flexMenu) {
              _context6.next = 12;
              break;
            }

            flexHome = flexMenu.countries.find(function (country) {
              return country.countryCode === homeCountryCode;
            });
            usesNewDesign = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_USE_NEW_ICON);
            usesNewDesignToSet = flexHome.usesNewDesign ? flexHome.usesNewDesign : false;

            if (!(usesNewDesign !== usesNewDesignToSet)) {
              _context6.next = 11;
              break;
            }

            _context6.next = 11;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_USE_NEW_ICON, usesNewDesignToSet);

          case 11:
            return _context6.abrupt("return", flexHome.usesNewDesign ? flexHome.usesNewDesign : false);

          case 12:
            return _context6.abrupt("return", false);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function updateDesign(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

exports.updateDesign = updateDesign;

var getFlexMenuData = function getFlexMenuData(contentPathArray, homeRegion) {
  var flexMenu = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU);

  var homeCountry = homeRegion || 'Germany';

  if (flexMenu) {
    var flexHome = flexMenu.countries.find(function (country) {
      return country.country === homeCountry;
    });

    var newDesign = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_USE_NEW_ICON);

    if (flexHome && flexHome.usesNewDesign !== newDesign) {
      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_USE_NEW_ICON, flexHome.usesNewDesign || false);
    }

    if (flexHome) {
      var flexId = null;

      if (contentPathArray.length > 2 && flexHome && flexHome.menu) {
        var flexParent = flexHome.menu.find(function (id) {
          return id.nodeID === contentPathArray[contentPathArray.length - 2];
        });

        if (flexParent.menu) {
          flexId = flexParent.menu.find(function (id) {
            return id.nodeID === contentPathArray[contentPathArray.length - 1];
          });
        }
      } else if (contentPathArray.length === 2 && flexHome && flexHome.menu) {
        flexId = flexHome.menu.find(function (id) {
          return id.nodeID === contentPathArray[contentPathArray.length - 1];
        });
      } // Not needed anymore, we now get the translation out of crowdin
      // const flexLanguage = flexMenu.languages.find(language => language.languageCode === languageCode)
      //
      // let title = null
      // let subtitle = null
      //
      // if (flexId && flexLanguage && flexLanguage[flexId.itemID]) {
      //   title = flexLanguage[flexId.itemID].menuTitle ? flexLanguage[flexId.itemID].menuTitle : null
      //   subtitle = flexLanguage[flexId.itemID].menuSubtitle ? flexLanguage[flexId.itemID].menuSubtitle : null
      // }
      // else {
      //   title = flexId && flexId.menuTitle ? flexId.menuTitle : null
      //   subtitle = flexId && flexId.menuSubtitle ? flexId.menuSubtitle : null
      // }
      //
      // if (title) {
      //   title = StringHelper.decodeHtmlEntities(title)
      // }
      // if (subtitle) {
      //   subtitle = StringHelper.decodeHtmlEntities(subtitle)
      // }


      console.log('newColor available?', _config["default"].isNewDesign && flexId && flexId.newColor);
      return {
        // title: title,
        // subtitle: subtitle,
        visible: flexId && flexId.visible,
        menuAction: flexId && flexId.menuAction ? flexId.menuAction : null,
        menuUrl: flexId && flexId.menuUrl ? flexId.menuUrl : null,
        color: _config["default"].isNewDesign && flexId && flexId.newColor ? flexId.newColor : flexId && flexId.color ? flexId.color : null,
        external: flexId && flexId.external ? flexId.external : false,
        isVisibleForCustomers: flexId && flexId.isVisibleForCustomers === true ? flexId.isVisibleForCustomers : false
      };
    }
  }
};

exports.getFlexMenuData = getFlexMenuData;